module.exports = __webpack_public_path__ + "img/phone-circle.ec137988.png";